<script>
  export default {
    name: 'navigation-item-badge',

    props: {
      item: {
        type: Object,
        required: true
      }
    }
  }
</script>

<template>
  <span v-if="item.badge" :style="[(item.children ? {'margin-right' : '30px'} : '')]" class="menu-badge" :class="[item.badge.class ? item.badge.class : 'default-badge']">
    {{ item.badge.text }}
  </span>
</template>
